export function renderFooter(): HTMLElement {

  const footer = document.createElement("footer")
  footer.className = "landing-footer"

  footer.innerHTML = `

  <div class="footer-inner">

    <a href="/">Головна</a>

    <a href="/faq.html">
      Питання / Відповіді
    </a>

    <a href="/terms.html">
      Умови використання
    </a>

    <a href="/privacy.html">
      Політика конфіденційності
    </a>
    
    <a href="/contact.html">
    Наші Контакти
    </a>

  </div>

  `

  return footer
}